import styled from 'astroturf/react';
import s from '../Capbox.styles';

const CapAssesmentResultWrapper = styled('div')`
  width: calc(100% - 30px);    
  margin: 15px;
  display: flex;
`;

const CapAssesmentResultTitle = styled('h2')`
  font-size: var(--ph-text-md);
  font-family: var(--ph-font-family-lato-heavy);
  line-height: 19px;
  color: var(--dark-blue);
  margin: 15px;
`;
const SubTitle = styled('div')`
  color: var(--dark-blue);
  line-height: 12px;
  margin-bottom: 9px;
  font-size: 11px;
  font-family: var(--ph-font-family-source-sans-pro-regular);
  font-weight: bold;
`;
const NumberBoxWrapper = styled('div')`
  float: left;
  width: 181px;    
`;

const NumberBox = styled('div')`
  width: 131px;
  height: 131px;
  border: 0.5px solid var(--dark-blue-50); 
  align-items: center;
  display: flex;
  text-align: center;
  justify-content: center;
  font-family: var(--ph-font-family-lato-regular);
  font-size: 60px;
  margin-right: 50px;
  @media screen and (max-width: 600px) {
    margin-right: 0px;
  }
`;

const SeverityTableWrapper = styled('div')`
  float: left;
  width: 181px;
`;

const SeverityTable = styled('div')`
  width: 100%;
`;

const SeverityTableItem = styled('div')`
  width: 131px;
  height: 23px;   
  margin-bottom: 4px;
  padding: 0 7px;
  line-height: 2.2;
  &:last-child {
    margin-bottom: 0px;
  }
  & > label{
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: block;
    width: calc(100% - 10px);
    float: left;
    font-family: var(--ph-font-family-lato-bold);
    font-size: 11px;
  }
  & > span{
    float: right;
    font-family: var(--ph-font-family-lato-bold);
    font-size: 11px;
  }
  &.bg-black{
    background-color: var(--dark-black);
    color: var(--white);
  }
  &.bg-extreme{
    background-color: var(--ph-red-500);
    color: var(--white);
  }
  &.bg-high{
    background-color: var(--high-orange);
    color: var(--white);
  }
  &.bg-medium{
    background-color: var(--medium-yellow);
    color: var(--dark-blue);
  }
  &.bg-midGrey{
    background-color: var(--ph-gray-250);
    color: var(--dark-blue);
  }
`;
export default {
    ...s,
    CapAssesmentResultWrapper,
    CapAssesmentResultTitle,
    SubTitle,
    NumberBoxWrapper,
    NumberBox,
    SeverityTableWrapper,
    SeverityTable,
    SeverityTableItem
}  
